import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";

export const DropDownButton = ({
  onItemClick,
  menuItems = [],
  trigger = null,
  disabled = false,
}) => {
  const id = React.useId();
  const buttonId = `${id}-button`;
  const menuId = `${id}-menu`;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {trigger === null ? (
        <Button
          id={buttonId}
          aria-controls={open ? menuId : undefined}
          aria-haspopup="true"
          aria-expanded={open}
          onClick={handleClick}
          variant="outlined"
          color="gray2"
          endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
          disabled={disabled}
        >
          Bulk Actions
        </Button>
      ) : (
        trigger(handleClick, open)
      )}
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": buttonId,
          },
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleClose();
              onItemClick && onItemClick(item);
            }}
            disabled={disabled}
          >
            {item?.label || item}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
